module.exports = "/_next/static/images/dakastarLogo-290c58425d9eb969eddee9a8dd42f4ee.svg";